<template>
  <v-card class="pa-3 ma-0">
    <v-layout row align-center justify-space-between pb-3>
      <h2>{{ isHtmlEdit? 'Edit Html Hint' : 'Add Html Hint' }}</h2>
      <v-btn
        flat
        fab
        small
        type="button"
        class="ma-0"
        data-dismiss="modal"
        @click="$emit('close')"
        aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-alert :value="true" type="error" v-if="err">
      {{err}}
    </v-alert>
    <div>
      <v-layout row wrap align-start justify-space-between>
        <v-flex xs12 py-2>
          <v-select
            label="Position/Name"
            :items="listItems"
            v-model="formData.name"
            hide-details
          />
        </v-flex>
        <v-flex xs12 px-0 py-2 v-if="formData.name !== 'webshop.logo' && formData.name !== 'webshop.headerImage.mobile'">
          <div class="pa-2" style="border: 1px solid #757575; border-radius: 4px">
            <v-textarea
              v-model="formData.value"
              label="Html Code"
            ></v-textarea>
          </div>
        </v-flex>
        <v-flex xs12 px-0 py-2 v-else>
          <v-layout row wrap p-2>
            <v-flex xs4>
              <v-img :src="logoPreview" contain max-height="200" max-width="389"></v-img>
            </v-flex>
            <v-flex xs8>
              <v-text-field
                prepend-icon="attach_file"
                single-line
                hide-details
                v-model="formData.name"
                :label="$lang.labels.upload"
                @click="startInput()"
                ref="logoField" />
              <input style="display: none;" type="file" accept="image/*" ref="logoInput" @change="onFileChange($event)">
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row justify-end>
        <v-btn color="primary" class="mx-0" @click="submitHtmlCode()">Submit</v-btn>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "HtmlHintsModal",
  props: ['htmlCode', 'isHtmlEdit', 'htmlKeysListFiltered'],
  data: () => ({
    listItems: [],
    formData: {
      name: '',
      value: '',
    },
    logoPreview: '',
    err: '',
  }),
  watch: {
    err(val) {
      if (val !== '') {
        setTimeout(() => { this.err = ''; }, 5000);
      }
    },
  },
  methods: {
    getFormData(files) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          resolve(null);
        };
      });
    },
    async onFileChange($event) {
      const files = $event.target.files || $event.dataTransfer.files
      if (files && files[0]) {
        const data = await this.getFormData(files);
        if (data === null) {
          this.err = 'Failed to convert image';
          return;
        }
        if (files[0].size > 512000) {
          this.err = 'The selected images is beyond limit of 512 KB.'
          // this.$set(this.formData, 'name', '');
          this.$set(this.formData, 'value', '');
          return;
        }
        const img = new Image();
        img.src = window.URL.createObjectURL(files[0]);
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          window.URL.revokeObjectURL( img.src );
          if( width > 800 || height > 600 ) {
            this.err = 'The maximum allowed resolution is 800 x 600.'
            // this.$set(this.formData, 'name', '');
            this.$set(this.formData, 'value', '');
            return;
          }
          // this.$set(this.formData, 'name', files[0].name);
          this.$set(this.formData, 'value', data);
          this.logoPreview = data;
        };
      } else {
        // this.$set(this.formData, 'name', '');
        this.$set(this.formData, 'value', '');
      }
    },
    startInput() {
      this.$refs.logoInput.click();
    },
    submitHtmlCode() {
      if (this.formData.name === '') {
        this.err = 'You must select Position/Name!';
        return
      }
      if (this.formData.value === '') {
        this.err = 'Value cannot be empty!';
        return;
      }
      this.$emit('submit', this.formData);
    },
  },
  created() {
    this.listItems = this.htmlKeysListFiltered.sort();
    if (this.htmlCode) {
      this.formData = this.htmlCode;
      this.listItems = [this.htmlCode.name].sort();
      if (this.htmlCode.name === 'webshop.logo' && this.htmlCode.value) this.logoPreview = this.htmlCode.value;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// HtmlHintsModal.vue?7b00b492